export default __webpack_public_path__ + "static/media/zvono.283f758b.mp3";